import React from 'react';
import "./style.scss";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from '@material-ui/icons/AddRounded';
import RemoveIcon from '@material-ui/icons/RemoveRounded';
import RouteTimeCircle from "../../../../RouteTimeCircle/RouteTimeCircle";


export default function SlaChanger({name, sla, disabled, onPlus, onMinus}) {
    function handlePlusClick() {
        if (onPlus)
            onPlus();
    }

    function handleMinusClick() {
        if (onMinus)
            onMinus();
    }

    return (
        <div className="sla-changer">
            <div className="sla-circle-wrapper-fixed-size"/>
            <div className="sla-circle-wrapper">
                <RouteTimeCircle status={"SCHEDULED"} totalDuration={1} durationTillFinish={1}>
                    <React.Fragment>
                        <div className="pie-chart-text-value">
                            {sla}
                        </div>
                        <div className="pie-chart-text-description">
                            דקות
                        </div>
                    </React.Fragment>
                </RouteTimeCircle>
                <div className="side-buttons">
                    <IconButton className="plus-button" size="small"
                                onClick={handlePlusClick}
                                disabled={disabled}>
                        <AddIcon fontSize="small"/>
                    </IconButton>
                    <IconButton className="minus-button" size="small"
                                onClick={handleMinusClick}
                                disabled={disabled}>
                        <RemoveIcon fontSize="small"/>
                    </IconButton>
                </div>
            </div>
            <div className="sla-title">
                {name}
            </div>
        </div>
    );
}
